import React from "react";
import { MessageCircle, Instagram } from "lucide-react";
import { LINKS } from "@/data/content";

const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-white/[0.06] py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center" data-testid="footer-logo">
          <img
            src="/portfolio/logo-white.png"
            alt="Capture By Parth Dixit"
            className="h-12 w-auto object-contain"
          />
        </div>

        <div className="flex items-center gap-5">
          <a
            data-testid="footer-whatsapp-link"
            href={LINKS.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-white/60 hover:text-gold transition-colors duration-300"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
          <a
            data-testid="footer-instagram-link"
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-white/60 hover:text-gold transition-colors duration-300"
          >
            <Instagram className="w-4 h-4" /> Instagram
          </a>
        </div>

        <p className="text-xs text-white/35 tracking-tight">
          © {new Date().getFullYear()} Capture By Parth Dixit
        </p>
      </div>
    </footer>
  );
};

export default Footer;
